import { render, staticRenderFns } from "./BuilderSeo.vue?vue&type=template&id=14d656c8"
import script from "./BuilderSeo.vue?vue&type=script&lang=js"
export * from "./BuilderSeo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports